<ngx-ui-loader [loaderId]="mainLoaderId"></ngx-ui-loader>
<router-outlet></router-outlet>
